"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PriceOfferList {
    constructor(priceOffers) {
        this.priceOffers = priceOffers;
    }
    isEmpty() {
        return this.priceOffers.length === 0;
    }
    getCount() {
        return this.priceOffers.length;
    }
    hasMultiplePriceOffers() {
        return this.priceOffers.length > 1;
    }
    getFirstOffer() {
        var _a;
        return (_a = this.priceOffers[0]) !== null && _a !== void 0 ? _a : null;
    }
    sortByCheapest() {
        this.priceOffers.sort((a, b) => a.amount.withoutVat - b.amount.withoutVat);
        return this;
    }
    getCheapestPriceOffer() {
        return this.sortByCheapest().getFirstOffer();
    }
    getFlexiblePriceOffers() {
        return new PriceOfferList(this
            .priceOffers
            .filter((priceOffer) => priceOffer.isFlexible()));
    }
}
exports.default = PriceOfferList;
